import { useEffect, useState } from 'react'
import { OverlayTrigger, Table, Tooltip } from 'react-bootstrap'
import {
  ArrowClockwise,
  GearFill,
  PlusCircleFill,
  TrashFill,
} from 'react-bootstrap-icons'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import VisualDataSvg from '../../../assets/illustration/visual-data.svg'
import { Ask } from '../../../components/Ask'
import { Center } from '../../../components/Center'
import { CustomButton } from '../../../components/CustomButton'
import { CustomSpinner } from '../../../components/CustomSpinner'
import Navbar from '../../../components/navbar/navbar'
import { useOrdenation } from '../../../hooks/useOrdenation'
import WmsInventarioService from '../../../services/database/WmsInventarioService'
import { formatDate } from '../../../utils/formatDate'
import { sendErrorApiMessage } from '../../../utils/sendErrorApiMessage'

export function WMSInventarios() {
  const [inventarios, setInventarios] = useState([])
  const [isInventariosLoading, setIsInventariosLoading] = useState(true)
  const [isDeleteInventarioLoading, setIsDeleteInventarioLoading] = useState({})

  const navigate = useNavigate()

  const { filteredItems, Th, Paginate } = useOrdenation(inventarios, 'id')

  async function handleDeleteInventory(id, index) {
    try {
      setIsDeleteInventarioLoading((prevState) => ({
        ...prevState,
        [index]: true,
      }))

      await WmsInventarioService.delete(id)

      toast.success('Inventário excluído com sucesso!')
      loadInventarios()
    } catch (err) {
      sendErrorApiMessage(err, 'Não foi possível excluir o inventário!')
    } finally {
      setIsDeleteInventarioLoading((prevState) => ({
        ...prevState,
        [index]: false,
      }))
    }
  }

  async function loadInventarios() {
    try {
      setIsInventariosLoading(true)

      const data = await WmsInventarioService.getAll()

      setInventarios(data)
    } catch (err) {
      sendErrorApiMessage(err, 'Não foi possível carregar os inventários')
    } finally {
      setIsInventariosLoading(false)
    }
  }

  useEffect(() => {
    loadInventarios()
  }, [])

  return (
    <>
      <Navbar />

      <div className="mt-page">
        <h1>Inventários</h1>

        <div
          style={{
            display: 'flex',
          }}
        >
          <CustomButton
            title="Novo Inventário"
            onClick={() => navigate('/wms/inventarios/novo')}
          >
            <PlusCircleFill />
          </CustomButton>

          <CustomButton
            title="Recarregar"
            onClick={loadInventarios}
            isDisabled={isInventariosLoading}
          >
            <ArrowClockwise />
          </CustomButton>
        </div>

        <div className="p-3">
          {isInventariosLoading ? (
            <Center column>
              <CustomSpinner />
              <h5>Carregando...</h5>
            </Center>
          ) : inventarios.length === 0 ? (
            <Center column>
              <h5>Sem inventários</h5>

              <img
                src={VisualDataSvg}
                alt=""
                style={{
                  width: 350,
                  height: 350,
                }}
              />
            </Center>
          ) : (
            <>
              <Table>
                <thead>
                  <tr>
                    <Th
                      label="ID"
                      value="id"
                    />
                    <Th
                      label="Descrição"
                      value="descricao"
                    />
                    <Th
                      label="Tipo"
                      value="tipo"
                    />
                    <Th
                      label="Status"
                      value="status"
                    />
                    <Th
                      label="Criado Em"
                      value="data_criacao"
                    />
                    <Th label="Ações" />
                  </tr>
                </thead>

                <tbody>
                  {filteredItems.map((inventario, index) => (
                    <tr key={inventario.id}>
                      <td>{inventario.id}</td>
                      <td>{inventario.descricao}</td>
                      <td>
                        {inventario.tipo.trim() == 'E' ? 'Endereço' : 'Produto'}
                      </td>
                      <td>
                        {inventario.status.trim() == 'A'
                          ? 'Aberto'
                          : inventario.status.trim() == 'F'
                            ? 'Finalizado'
                            : 'Cancelado'}
                      </td>
                      <td>
                        {formatDate(inventario.data_criacao, 'dd/MM/yy, HH:mm')}
                      </td>
                      <td>
                        <Center>
                          <OverlayTrigger
                            overlay={<Tooltip>Gerenciar</Tooltip>}
                          >
                            <CustomButton
                              noMargin
                              isEdit
                              onClick={() =>
                                navigate(`/wms/inventarios/${inventario.id}`)
                              }
                            >
                              <GearFill />
                            </CustomButton>
                          </OverlayTrigger>

                          <OverlayTrigger overlay={<Tooltip>Excluir</Tooltip>}>
                            <CustomButton
                              noMargin
                              isDelete
                              isLoading={isDeleteInventarioLoading[index]}
                              onClick={() =>
                                Ask('Deseja excluir esse inventário?', () =>
                                  handleDeleteInventory(inventario.id, index),
                                )
                              }
                            >
                              <TrashFill />
                            </CustomButton>
                          </OverlayTrigger>
                        </Center>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>

              <Paginate />
            </>
          )}
        </div>
      </div>
    </>
  )
}
